"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.sortSpecialLinks = exports.sortLinks = exports.isSpecialLink = exports.getOrderedLinks = void 0;
var _models = require("../../../models");
var _constants = require("../constants");
const isSpecialLink = link => Object.keys(_models.SpecialLinks).find(specialLink => specialLink === link.linkType);
exports.isSpecialLink = isSpecialLink;
const sortLinks = (linkA, linkB) => {
  const priorityA = _constants.LINK_PRIORITIES.indexOf(linkA.linkType);
  const priorityB = _constants.LINK_PRIORITIES.indexOf(linkB.linkType);
  if (priorityA === -1 && priorityB === -1) {
    return _constants.EQUAL_LINKS;
  }
  if (priorityA === -1) {
    return _constants.LINK_B_FIRST;
  }
  if (priorityB === -1) {
    return _constants.LINK_A_FIRST;
  }
  return priorityA - priorityB;
};
exports.sortLinks = sortLinks;
const sortSpecialLinks = (linkA, linkB) => {
  if (_models.SpecialLinksOrder[linkA.linkType] < _models.SpecialLinksOrder[linkB.linkType]) {
    return _constants.LINK_A_FIRST;
  }
  return _constants.LINK_B_FIRST;
};
exports.sortSpecialLinks = sortSpecialLinks;
const getOrderedLinks = items => {
  const commonLinks = items.filter(link => !isSpecialLink(link) && !_constants.TOP_LINKS.includes(link.linkType));
  const orderedCommonLinks = commonLinks.sort(sortLinks);
  const specialLinks = items.filter(link => isSpecialLink(link));
  const orderedSpecialLinks = specialLinks.sort(sortSpecialLinks);
  const topLinks = items.filter(link => _constants.TOP_LINKS.includes(link.linkType));
  return {
    orderedCommonLinks,
    orderedSpecialLinks,
    topLinks
  };
};
exports.getOrderedLinks = getOrderedLinks;
